import { StyleSheet, TextStyle } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';
import { IS_WEB } from '@/utils/platform';

export const styles = StyleSheet.create({
  fieldOuter: {
    borderRadius: theme.borderRadii.lg,
    padding: 2,
    borderWidth: 2,
    borderColor: 'transparent',
    marginLeft: -2,
  },
  fieldOuterOpen: {
    borderColor: colors.newUI.therapist.blue50,
  },
  field: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.spacings.sm,
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderBottomWidth: 2,
    borderBottomColor: colors.newUI.therapist.primaryBlue80,
    minHeight: 60,
  },
  fieldContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacings.sm,
    paddingVertical: theme.spacings.sm,
  },
  placeholder: {
    fontSize: theme.fontSizes.base,
    color: colors.newUI.therapist.grey50,
  },
  searchInput: {
    flex: 1,
    minWidth: 120,
    fontSize: theme.fontSizes.base,
    color: colors.newUI.therapist.primaryBlue80,
    ...((IS_WEB
      ? { outlineStyle: 'none' }
      : { outlineColor: 'none' }) as TextStyle),
  },
  chevron: {
    width: 60,
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.newUI.therapist.blue20,
  },
  selectedTag: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacings.sm,
    borderRadius: theme.borderRadii.lg,
    borderWidth: 1,
    borderColor: colors.newUI.therapist.blue50,
    backgroundColor: colors.white,
    paddingVertical: theme.spacings.xs,
    paddingHorizontal: theme.spacings.sm,
  },
  selectedTagLabel: {
    fontSize: theme.fontSizes.sm,
    color: colors.newUI.therapist.primaryBlue80,
  },
  list: {
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: colors.newUI.therapist.primaryBlue80,
    borderBottomLeftRadius: theme.borderRadii.xl,
    borderBottomRightRadius: theme.borderRadii.xl,
    backgroundColor: colors.white,
    overflow: 'hidden',
  },
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: theme.spacings.sm,
    paddingHorizontal: theme.spacings.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.newUI.therapist.primaryBlue10,
  },
  optionLabel: {
    flexShrink: 1,
    fontSize: theme.fontSizes.sm,
    color: colors.newUI.therapist.textBlue100,
    paddingVertical: theme.spacings.sm,
    paddingHorizontal: theme.spacings.sm,
    borderWidth: 1,
    borderColor: colors.newUI.therapist.blue90,
    borderRadius: theme.borderRadii.lg,
  },
  optionLabelSelected: {
    borderColor: colors.newUI.therapist.blue50,
  },
  addRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacings.sm,
    paddingVertical: theme.spacings.md,
    paddingHorizontal: theme.spacings.md,
  },
  addLabel: {
    flexShrink: 1,
    fontSize: theme.fontSizes.sm,
    color: colors.newUI.therapist.primaryBlue80,
  },
  emptyLabel: {
    fontSize: theme.fontSizes.sm,
    color: colors.newUI.therapist.grey70,
    paddingVertical: theme.spacings.md,
    paddingHorizontal: theme.spacings.md,
  },
});
